// extracted by mini-css-extract-plugin
export default {"ComponentWrapper":"CustomSearch_ComponentWrapper__s4o79","MainWrapper":"CustomSearch_MainWrapper__miVPH"};